// https://github.com/mui-org/material-ui-x/pull/1070
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Popper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';

import StyledPaper from '../styled/paper';

const useStyles = makeStyles(theme => ({
    root: {
        alignItems: 'center',
        lineHeight: '24px',
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        '& .MuiRating-root': {
            marginRight: theme.spacing(1)
        },
        '& .cellValue': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    value: {
        padding: 10,
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere',
    },
}));

const CellExpand = React.memo(function CellExpand (props) {
    const { width, value } = props;
    const wrapper = useRef(null);
    const cellDiv = useRef(null);
    const cellValue = useRef(null);
    const [anchorEl, setAnchorEl] = useState();

    const classes = useStyles();
    const [showFullCell, setShowFullCell] = useState(false);
    const [showPopper, setShowPopper] = useState(false);

    const showCell = useCallback(() => {
        setShowFullCell(true);
    }, []);
    const hideCell = useCallback(() => {
        setShowFullCell(false);
    }, []);

    const isOverflown = (element) => {
        return (
            element.scrollHeight > element.clientHeight ||
            element.scrollWidth > element.clientWidth
        );
    };

    useEffect(() => {
        if (cellDiv.current) {
            setAnchorEl(cellDiv.current);
        }
    }, []);
    useEffect(() => {
        if (cellValue && cellValue.current) {
            const isCurrentlyOverflown = isOverflown(cellValue.current);
            setShowPopper(isCurrentlyOverflown);
        }
    }, [width]);

    return (
        <div
            ref={wrapper}
            className={classes.root}
            onMouseEnter={showCell}
            onMouseLeave={hideCell}>
            <div
                ref={cellDiv}
                style={{
                    height: 1,
                    width,
                    display: 'block',
                    position: 'absolute',
                    top: 0
                }}/>
            <div ref={cellValue} className="cellValue">
                {value}
            </div>
            {showPopper && (
                <Popper
                    id={'123'}
                    open={showFullCell && anchorEl != null}
                    anchorEl={anchorEl}
                    style={{ width: width, zIndex: 1500 }}>
                    <StyledPaper
                        className={classes.paper}
                        elevation={1}
                        style={{ minHeight: wrapper.current.offsetHeight - 2 }}>
                        <div className={classes.value}>{value}</div>
                    </StyledPaper>
                </Popper>
            )}
        </div>
    );
});
CellExpand.propTypes = {
    width: PropTypes.number,
    value: PropTypes.string,
};

export default function RenderCellExpand (params) {
    return (
        <CellExpand
            value={params.value ? params.value.toString() : ''}
            width={params.colDef.width}/>
    );
}
